import React, { useEffect } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LongMenu from "../../components/LongMenu";
import { getUserEmail, mapDispatchToProps, mapStateToProps } from "../../helpers";
import { connect } from "react-redux";
import { Box, useMediaQuery, useTheme } from "@mui/material";

function ProfileCard(props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  let username;
  useEffect(() => {
    username = localStorage.getItem("user_email");
  }, [props.getLoansDataRes]);

  return (
    <div className="flexAlignRowClassName">
      {!isSmallScreen ? (
        <Box className="mainHeaderDiv" sx={{ width: "100%" }}>
          <Box className="iconDiv">
            <AccountCircleIcon sx={{ fontSize: "38px", mt: "4px" }} />
            <Box>
              <Box sx={{ color: "#000", textTransform: "capitalize" }}>
                {localStorage.getItem("username")}
              </Box>
              <Box sx={{ color: "#000", fontSize: "12px" }}>
                {getUserEmail()}
              </Box>
            </Box>
            <Box sx={{ ml: getUserEmail() ? "0px" : "170px" }}>
              <LongMenu logout={() => props.signOutClickHandler()} />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={{ color: "#00634a", display: "flex" }}>
          <AccountCircleIcon sx={{ fontSize: "38px", mt: "4px" }} />
          <LongMenu logout={() => props.signOutClickHandler()} />
        </Box>
      )}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileCard);
export { ProfileCard };
